import { User } from "@/types/models/User.interface";

export const getCapitalizedFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase();

export const getUserInitials = (name: string, lastName: string) =>
  `${getCapitalizedFirstLetter(name)}${getCapitalizedFirstLetter(lastName)}`;

export const getIsLiteUser = (
  hasAccessToLite: boolean,
  hasNceTrialCampaign: boolean,
  licenses: User["licenses"] = [],
) =>
  hasAccessToLite &&
  !hasNceTrialCampaign &&
  !licenses.some((license) => license.is_active);
